import axios from 'axios'
import { TransactionHeaderName } from '@/store/modules/Transaction'

const handleNonJsonError = function (error) {
  if (error.response && error.response.headers) {
    if (error.response.headers['content-type'] !== 'application/json') {
      error.response.data = 'Ufff! Leider ist gerade ein Fehler aufgetreten (Fehler: ' + error.response.status + '). Bitte probier\'s gleich noch einmal oder melde dich telefonisch.'
    }
  }
  if (error.message.indexOf(9999) > 0) {
    error.message = "Ufff! Ein Fehler ist aufgetreten (Fehler: L4). Bitte probier's noch einmal."
  }
  throw error
}

export const TransactionName = 'Auth'

const AuthenticationModule = {
  state: {
    authenticationToken: null,
    laoding: false
  },
  mutations: {
    authenticate (state, authenticationToken) {
      const expiresAt = new Date()
      expiresAt.setSeconds(expiresAt.getSeconds() + authenticationToken.expires_in)
      state.authenticationToken = {
        accessToken: authenticationToken.access_token,
        refreshToken: authenticationToken.refresh_token,
        expiresAtTS: expiresAt.getTime()
      }
      if (!authenticationToken.prevent_sync && window.$vue3 && window.$vue3.setAuthTokens) {
        window.$vue3.setAuthTokens(authenticationToken.access_token, authenticationToken.refresh_token)
      }
    },
    logout (state) {
      state.authenticationToken = null
      window.$vue3.setAuthTokens('', '')
    }
  },
  actions: {
    async login ({ commit, state, getters }, { username, password }) {
      if (state.loading) {
        throw new Error("Ufff! Ein Fehler ist aufgetreten (Fehler: L5). Bitte probier's noch einmal.")
      }
      try {
        commit('clearMessages', {}, { root: true })
        commit('Transaction/createTransactionId', TransactionName)
        const headers = {}
        state.loading = true
        headers[TransactionHeaderName] = getters['Transaction/transactionIds'][TransactionName]
        const response = await axios({
          method: 'post',
          url: getters.baseUrl + '/api/token',
          timeout: 19999,
          data: {
            grant_type: 'password',
            client_id: getters.clientId,
            client_secret: getters.clientSecret,
            username: username,
            password: password
          },
          headers
        })
        state.loading = false
        commit('authenticate', response.data)
        commit('Transaction/updateAccessTokenHash', TransactionName)
        return state.authenticationToken.accessToken
      } catch (error) {
        state.loading = false
        throw handleNonJsonError(error)
      }
    },
    async logout ({ commit, state, getters }) {
      if (state.authenticationToken?.accessToken) {
        const headers = {}
        headers[TransactionHeaderName] = getters['Transaction/transactionIds'][TransactionName]

        await axios.delete(getters.baseUrl + '/api/token', {
          data: {
            access_token: state.authenticationToken.accessToken
          },
          headers
        })
      }

      commit('logout')
      commit('Transaction/resetTransactionId', TransactionName)
    },
    updateAuthTokens ({ commit, state }, authenticationToken) {
      if (state.authenticationToken?.accessToken !== authenticationToken.access_token) {
        commit('authenticate', authenticationToken)
      }
    },
    removeAuthTokens ({ commit }) {
      commit('authenticate', {
        access_token: '',
        refresh_token: '',
        expires_in: 0
      })
    }
  },
  getters: {
    isAuthenticated: state => {
      return state.authenticationToken?.accessToken != null
    },
    accessToken: state => {
      return state.authenticationToken?.accessToken
    },
    refreshToken: state => {
      return state.authenticationToken?.refreshToken
    }
  }
}

export {
  AuthenticationModule
}
